import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { httpRequest } from 'utils/httpRequest';
import { Pagination } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { toast } from 'react-toastify';
import CircleLoader from "components/loader/CircleLoader"
import { useLoader } from 'components/loader/useLoader';

const PodcastManagement = () => {

     const { loading, startLoading, stopLoading } = useLoader()


    const [podcastData, setPodcastData] = useState([])
    const [activePage, setActivePage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [total, setTotal] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
  

    const [data, setData] = useState([
        { id: 1, name: 'John Doe', email: 'john@example.com', },
        { id: 2, name: 'Jane Smith', email: 'jane@example.com', },
        { id: 3, name: 'Mike Johnson', email: 'mike@example.com', },
        { id: 4, name: 'Sarah Wilson', email: 'sarah@example.com', },
        { id: 5, name: 'Tom Brown', email: 'tom@example.com', },
        { id: 6, name: 'Lisa Davis', email: 'lisa@example.com', },
        { id: 7, name: 'Mark Taylor', email: 'mark@example.com', },
    ]);

    const navigate = useNavigate();




    const handleDelete = async (podcastId) => {
        try {

            const response = await httpRequest(
                `podcast/delete/${podcastId}`,
                "DELETE",
                {
                },
                {},
                true,
                false
            );


            if (response?.code === 200) {
                console.log("podcast deleted successfully")
                toast.success("Podcast deleted successfully")
                const newTotal = total - 1;
                const maxPageAfterDelete = Math.ceil(newTotal / limit);
                const newPage = Math.min(activePage, maxPageAfterDelete);

                setTotal(newTotal); // optional
                setActivePage(newPage); // optional if not calling set again inside getPodcast
                getPodcast(newPage, limit);
                // getPodcast(activePage,limit)

            }

        } catch (error) {
            console.log(error);
          
        }
    };

    const handleEdit = (podcastId) => {
        navigate(`/admin/edit-podcast/${podcastId}`)
    };



    const handleNavigationOnAddPodcast = () => {
        navigate("/admin/add-podcast");
    }



    //get podcast'

    useEffect(() => {
        getPodcast(activePage, limit)
    }, [])








    const getPodcast = async (page = 1, pageLimit = 10) => {
        startLoading()
        try {

            const response = await httpRequest(
                "podcast/list",
                "GET",
                {
                },
                {
                    page: page,
                    limit: pageLimit
                },
                true,
                false
            );
            if (response?.code === 200) {
                setPodcastData(response?.data);
                setTotal(response?.total);
                setActivePage(response?.page);
                setLimit(response?.limit);


            }

        } catch (error) {
            console.log(error);
        }finally{
            stopLoading()
        }
    }

    const handlePageChange = (page) => {
        setActivePage(page);
        getPodcast(page, limit);
    };

    // Handle limit change
    const handleLimitChange = (newLimit) => {
        setLimit(newLimit);
        setActivePage(1); // Reset to first page
        getPodcast(1, newLimit);
    };
















    return (
        <>


    {loading ? <CircleLoader/> :(       <div className="container-fluid py-4 mt-5">

                <div className="row">
                    <div className="col">
                        <div className="card shadow">
                            {/* Card Header */}
                            <div className="card-header border-0 d-flex justify-content-end">
                                <h3 className="mb-0 mr-auto">Podcast Management</h3>
                                <Button color="primary" size="sm" onClick={handleNavigationOnAddPodcast}>
                                    Add Podcast
                                </Button>
                            </div>

                            {/* Table */}
                            <div className="table-responsive">
                                <table className="table align-items-center table-flush">
                                    <thead className="thead-light">
                                        <tr>
                                            <th scope="col">S.No</th>
                                            <th scope="col"> Title</th>

                                            <th scope="col">Action</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {podcastData && podcastData.length > 0 && podcastData.map((item, index) => (
                                            <tr key={item._id}>

                                                <td>
                                                    <span className="mb-0 text-sm font-weight-bold">
                                                    {(activePage - 1) * limit + index + 1}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="mb-0 text-sm font-weight-bold">
                                                        {item.title}
                                                    </span>
                                                </td>


                                                <td>
                                                    <button
                                                        className="btn  btn-sm"
                                                        onClick={() => handleEdit(item._id)}

                                                        title="Delete"
                                                    >
                                                        <i className="fas fa-edit text-primary me-2" title="Edit"></i>

                                                    </button>
                                                    <button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleDelete(item._id)}
                                                        title="Delete"
                                                    >
                                                        <i className="fas fa-trash"></i>

                                                    </button>

                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Card Footer with Pagination */}
                            <div className="card-footer py-4">
                                <div className="d-flex justify-content-end">
                                    <Pagination
                                        size="sm"
                                        total={total}
                                        limit={limit}
                                        activePage={activePage}
                                        onChangePage={handlePageChange}
                                        maxButtons={5}
                                        prev
                                        next
                                        last
                                        first
                                        ellipsis
                                    />
                                </div>

                                {/* <div className="text-center mt-2">
                                    <small className="text-muted">
                                        Showing {podcastData.length > 0 ? ((activePage - 1) * limit) + 1 : 0} to {Math.min(activePage * limit, total)} of {total} podcasts
                                    </small>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>)}



        </>
    );
};

export default PodcastManagement;